export default "__VITE_ASSET__79a652fd__"